import React from 'react';
import PropTypes from 'prop-types';

import Flex from '@decisiv/ui-components/lib/components/Flex';

import SeverityItem from './SeverityItem';

export default function SeverityColumn({ severities, loading, marginBottom }) {
  return (
    <Flex flexDirection="column" marginLeft={1} marginBottom={marginBottom}>
      {severities.map((severity, index) => (
        <Flex
          key={severity.severity}
          flexDirection="column"
          marginLeft={1}
          marginTop={index > 0 ? 3 : 0}
        >
          <SeverityItem
            severity={severity.severity}
            count={severity.count}
            loading={loading}
            to={severity.to}
            text={severity.text}
          />
        </Flex>
      ))}
    </Flex>
  );
}

SeverityColumn.propTypes = {
  severities: PropTypes.arrayOf(
    PropTypes.shape({
      severity: PropTypes.string.isRequired,
      count: PropTypes.number,
      to: PropTypes.string.isRequired,
      text: PropTypes.node,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  marginBottom: PropTypes.number,
};

SeverityColumn.defaultProps = {
  marginBottom: undefined,
};
